// We have some hard coded English copy in byzantine that we must
// map to fluent ids for the OLB product FTL
export const BYZANTINE_COPY_TO_FLUENT_ID: Record<string, string> = {
  Active: "org-user-status-active",
  Pending: "org-user-status-invited",
  Inactive: "org-user-status-inactive",
  "Account Holder": "org-user-role-account-holder",
  Admin: "org-user-role-admin",
  Viewer: "org-user-role-viewer",
  Collaborator: "org-user-role-collaborator",
  Unassigned: "org-user-role-unassigned",
  Deactivated: "org-user-status-deactivated",
};

export const STATUS_CHIP_KINDS: Record<string, string> = {
  Active: "success",
  Pending: "warn",
  Inactive: "info",
};

export const STATUS_CHIP_ICONS: Record<string, string> = {
  Active: "check",
  Pending: "hourglass",
  Inactive: "x",
};
